import { defineComponent, nextTick } from "vue";
import axios from 'axios'

import { store } from '#stores/ptosis.js'
import { VForm } from "vuetify/components";

import Form from '../form.js'

export default defineComponent({
    mixins: [ Form ],
    components: {
    },
    data() {
        return {
            store,
            form: store.ptosisForm
        }
    },
    methods: {
        async submitHook(fd:FormData) {
        }
    }
})
